var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDown = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.6964L6.93946 7.63589C6.79559 7.49202 6.61248 7.42008 6.39013 7.42008C6.16779 7.42008 5.98468 7.49202 5.84081 7.63589C5.69694 7.77976 5.625 7.96287 5.625 8.18522C5.625 8.40756 5.69694 8.59067 5.84081 8.73454L9.45067 12.3444C9.60762 12.5014 9.79073 12.5798 10 12.5798C10.2093 12.5798 10.3924 12.5014 10.5493 12.3444L14.1592 8.73454C14.3031 8.59067 14.375 8.40756 14.375 8.18522C14.375 7.96287 14.3031 7.77976 14.1592 7.63589C14.0153 7.49202 13.8322 7.42008 13.6099 7.42008C13.3875 7.42008 13.2044 7.49202 13.0605 7.63589L10 10.6964Z",
    fill: "#242424"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-down.f0f73e56f371c72af40a169c1a69394a.svg";